import { render } from "./RuleLabel.vue?vue&type=template&id=f9d59c34"
import script from "./RuleLabel.vue?vue&type=script&lang=js"
export * from "./RuleLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__